// extracted by mini-css-extract-plugin
export default {"item":"_db4246ec","headerContainer":"_e34cab01","title":"_46378099","discoverLink":"_762b792a","module":"_830ad8e3","dotsWrapper":"_8a351c26","spinContainer":"_ce3573ba"};